<p-dialog
  [(visible)]="display"
  [style]="{ width: '95vw' }"
  (onHide)="reloadDocumentDetail()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <app-read-only readonlyText="Review Status"></app-read-only>
  </ng-template>
  <div id="reviewStatusModal">
    <app-panel-list *ngIf="!showLoader" [panelList]="reviewStatusData" [noResultFound] = "!isReviewStatusDataAvailable">
      <ng-template #templateRef let-data="dataVar">
        <div panel-content>
          <div class="grid">
            <div class="col-10">
                <div class="grid">
                    <div class="col-6 text-left">
                      <app-label labelText="Reviewer"></app-label>
                      <app-read-only [ngClass]="{'inActiveGroup': data?.isReviewerTerminated===true}"
                        readonlyText="{{ data?.reviewer }}"
                      ></app-read-only>
                    </div>
                    <div class="col-3 text-left">
                      <app-label labelText="Status"></app-label>
                      <div class="grid">
                        <div class="col max-w-0">
                          <em
                            class="pi pi-circle-fill"
                            [ngClass]="{
                              pending: data?.status == 0,
                              completed: data?.status == 1
                            }"
                          ></em>
                        </div>
                        <div class="col ml-1">
                          <app-read-only
                            readonlyText="{{ data?.statusName }}"
                          ></app-read-only>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 text-left">
                      <app-label labelText="Reviewed Date"></app-label>
                      <app-read-only
                        readonlyText="{{ data?.reviewedDate | date : 'dd-MMM-yyyy' }}"
                      ></app-read-only>
                    </div>
                    <div class="col-12" *ngIf="data?.delegateTo?.length > 0">
                      <div class="mb-2 overflow-ellipsis">
                        <app-label labelText="{{ 'Delegate To' }}"></app-label>
                        <div *ngFor="let delegateReviewer of data.delegateToInformation">
                          <app-read-only [ngClass]="{'inActiveGroup': delegateReviewer.isTerminated===true}"
                            readonlyText="{{ delegateReviewer.name }}"
                          ></app-read-only>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
            <div class="col-2 text-left m-auto"
              *ngIf="data?.completeButtonFlag && showCompleteButton && !showCompleteButtonWhenFileCheckedOut"
            >
              <p-button
              appPreventDoubleClick
                label="Complete"
                icon="fas fa-check"
                id="reviewStatusButton"
                iconPos="left"
                (debounceClick)="updateReviewStatus(data)"
              ></p-button>
            </div>
        </div>
        </div>
      </ng-template>
    </app-panel-list>
  </div>
</p-dialog>

<p-dialog
  [(visible)]="showEsignatureConfirmationDialog"
  [style]="{ width: '30vw' }"
  (onHide)="closeConfirmationModal()"
  [modal]="true"
>
  <ng-template pTemplate="header">
    <span class="font-semibold text-xl">Confirmation</span>
  </ng-template>
  <div>
    <em class="pi pi-exclamation-triangle mr-2 font-semibold"></em>
    <span>{{ confirmationMessage }}</span>
  </div>
  <ng-template pTemplate="footer">
    <p-button
    appPreventDoubleClick
      label="No"
      type="submit"
      icon="pi pi-times"
      id="closeEsignature"
      styleClass="p-button-outlined"
      class="align-right"
      (debounceClick)="closeConfirmationModal()"
    >
    </p-button>
    <p-button
    appPreventDoubleClick
      label="Yes"
      icon="pi pi-check"
      type="submit"
      id="saveEsignature"
      class="align-right"
      (debounceClick)="onConfirm()"
    >
    </p-button>
    
  </ng-template>
</p-dialog>

<div *ngIf="displayCRIHistoryModal">
  <app-change-request-history-modal
    [documentDetailsDto]="documentDetailsDto"
    [isChangeRequestHistoryModalShow]="isChangeRequestHistoryModalShow"
    [isLatestVersion]="true"
    [documentPhase]="documentPhase"
    (isCloseChangeRequestItemHistoryModal)="
      closeChangeRequestItemHistoryModal($event)
    "
    (isLatestDocument)="updateIsLatestVersion($event)"
    [isTriggeredFromReview]="isTriggeredFromReview"
    (isReviewStatusModalVisible)="updateReviewStatusAfterProceed($event)"
  >
  </app-change-request-history-modal>
</div>
